import React from 'react';
import { motion } from 'framer-motion';
import { Container } from './ui/Container';
import { ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function GuaranteeSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-24 bg-white" data-id="element-144">
      <Container data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto text-center" data-id="element-146">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-blue-50 mb-8" data-id="element-147">
            <ShieldCheck className="w-10 h-10 text-[#1E40AF]" data-id="element-148" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif text-gray-900 mb-8" data-id="element-149">
            60 Night Money Back Guarantee
          </h2>

          <div className="space-y-6 text-lg text-gray-600 leading-relaxed mb-10" data-id="element-150">
            <p data-id="element-151">Try SnoreStop™ for a full 60 nights.</p>
            <p data-id="element-152">
              If you do not notice an improvement in your nightly sleep
              experience, simply contact us for a full refund.
            </p>
            <div className="flex justify-center gap-6 text-gray-800 font-medium py-4" data-id="element-153">
              <span data-id="element-154">No complicated process.</span>
              <span data-id="element-155">No stress.</span>
              <span data-id="element-156">No risk.</span>
            </div>
            <p className="italic" data-id="element-157">
              Because better sleep should feel easy to try.
            </p>
          </div>

          <Button onClick={scrollToPricing} size="lg" className="px-8" data-id="element-158">
            I Want Quiet Nights Back
          </Button>
        </motion.div>
      </Container>
    </section>;
}